import CryptoJS from 'crypto-js';

export const encryptData = (
  inputValue: string | undefined,
  csrfToken: string | undefined
): string => {
  if (!inputValue || !csrfToken) {
    return inputValue || '';
  }
  return CryptoJS.AES.encrypt(inputValue, csrfToken).toString();
};

export const decryptData = (
  encryptedInput: string | undefined,
  csrfToken: string | undefined
): string => {
  if (!csrfToken || !encryptedInput) {
    return encryptedInput || '';
  }
  const bytes = CryptoJS.AES.decrypt(encryptedInput, csrfToken);
  return bytes.toString(CryptoJS.enc.Utf8);
};
